import { Link } from "react-router-dom";
import { Hero } from "@/components/sections/Hero";
import { LiveFeatures } from "@/components/sections/LiveFeatures";
import { Features } from "@/components/sections/Features";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { Pricing } from "@/components/sections/Pricing";
import { Testimonials } from "@/components/sections/Testimonials";
import { FaqSection } from "@/components/sections/FAQ";
import { Contact } from "@/components/sections/Contact";
import { Button } from "@/components/ui/button";
import { ArrowRight, Smartphone } from "lucide-react";
import { whyUs } from "@/data/siteContent";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { SHOP } from "@/constants/testIds";

const WhyUs = () => (
  <section className="py-12 sm:py-16">
    <div className="container-x">
      <StaggerGroup className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {whyUs.map((w) => (
          <StaggerItem key={w.title}>
            <div className="h-full rounded-2xl border border-border bg-card p-5 sm:p-6 glow-hover card-lift">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-accent glow">
                <w.icon className="h-5 w-5" />
              </span>
              <h3 className="mt-4 text-base font-semibold">{w.title}</h3>
              <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{w.desc}</p>
            </div>
          </StaggerItem>
        ))}
      </StaggerGroup>
    </div>
  </section>
);

const ShopCTA = () => (
  <section className="py-12 sm:py-16">
    <div className="container-x">
      <div className="relative overflow-hidden rounded-3xl border border-border bg-card p-8 sm:p-12 glow">
        <div className="absolute inset-0 hero-glow opacity-70" />
        <div className="relative flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-sm font-semibold text-accent uppercase tracking-wider">Shop Telefoni</p>
            <h3 className="mt-2 text-2xl sm:text-3xl font-semibold tracking-tight">Preferisci un telefono già pronto all'uso?</h3>
            <p className="mt-3 text-muted-foreground max-w-xl leading-relaxed">
              Scopri gli smartphone Samsung, Oppo e Motorola (inclusi i pieghevoli Galaxy Z Flip) con il servizio già
              installato e 1 anno di pannello cloud incluso.
            </p>
          </div>
          <Button asChild size="lg" data-testid={SHOP.cta} className="rounded-xl glow-hover h-12 px-7 text-base shrink-0">
            <Link to="/shop"><Smartphone className="h-5 w-5" /> Vai allo Shop <ArrowRight className="h-4 w-4" /></Link>
          </Button>
        </div>
      </div>
    </div>
  </section>
);

export default function Home() {
  return (
    <>
      <Hero />
      <LiveFeatures />
      <WhyUs />
      <Features />
      <HowItWorks />
      <Pricing />
      <ShopCTA />
      <Testimonials />
      <FaqSection />
      <Contact />
    </>
  );
}
